export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings"])},
        "audioInput": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Audio Input"])},
        "videoInput": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Camera"])},
        "ringtone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ringtone volume"])},
        "call": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Call volume"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Close settings"])}
      },
      "ru": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки"])},
        "audioInput": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Микрофон"])},
        "videoInput": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Камера"])},
        "ringtone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Громкость рингтона"])},
        "call": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Громкость звонка"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Закрыть настройки"])}
      }
    }
  })
}
